module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16.6c551c04.webp";